import React from 'react';

function LoginForm({ email, setEmail, password, setPassword, errorMessage, handleForgotPasswordClick, handleLogin }) {
	const handleSubmit = (e) => {
		e.preventDefault();
		handleLogin();
	};

	return (
		<form className="login-form" onSubmit={handleSubmit} noValidate>
			<div className="login-field">
				<label className="login-label" htmlFor="login-email">Email</label>
				<input
					id="login-email"
					className={`login-input${errorMessage ? ' login-input--error' : ''}`}
					type="email"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					autoComplete="email"
					required
				/>
			</div>
			<div className="login-field">
				<label className="login-label" htmlFor="login-password">Password</label>
				<input
					id="login-password"
					className={`login-input${errorMessage ? ' login-input--error' : ''}`}
					type="password"
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					autoComplete="current-password"
					required
				/>
			</div>
			{errorMessage && (
				<div className="login-error">{errorMessage}</div>
			)}
			<div className="login-forgot-row">
				<button type="button" className="login-forgot-btn" onClick={handleForgotPasswordClick}>
					Forgot password?
				</button>
			</div>
			<button type="submit" className="login-submit">
				Sign in
			</button>
		</form>
	);
}

export default LoginForm;
